
import React from "react";

const plans = [
  {
    name: "Starter",
    price: "$9/month",
    features: {
      "Product Limit": "Up to 20 products",
      "Product Variants": "❌ No variants",
      "Checkout System": "✅ Basic checkout",
      "Mobile Responsive": "✅ Yes",
      "Payment Integration": "❌ None (manual/offline only)",
      "Shipping Options": "❌ Flat note only",
      "Customer Accounts": "❌ No login or account system",
      "Admin Dashboard": "✅ Basic product & order view",
      "Design Customization": "✅ Basic themes",
      "Email Notifications": "❌ None",
      "SEO & Marketing Tools": "❌ None",
      "Blog / CMS": "❌ Not included",
      "Support": "✅ Email / ticket",
      "Hosting & SSL": "✅ Included",
      "Reports & Analytics": "❌ None",
      "Apps & Integrations": "❌ None",
    },
  },
  {
    name: "Pro",
    price: "$29/month",
    features: {
      "Product Limit": "Up to 500 products",
      "Product Variants": "✅ Basic variants",
      "Checkout System": "✅ Integrated with Stripe or PayPal",
      "Mobile Responsive": "✅ Yes",
      "Payment Integration": "✅ Stripe, PayPal",
      "Shipping Options": "✅ Flat rate & zone-based shipping",
      "Customer Accounts": "✅ Optional login, order tracking",
      "Admin Dashboard": "✅ Full product, orders, and user management",
      "Design Customization": "✅ Theme editor + custom CSS",
      "Email Notifications": "✅ Order confirmation emails",
      "SEO & Marketing Tools": "✅ Meta tags, Google Analytics",
      "Blog / CMS": "✅ Optional blog feature",
      "Support": "✅ Priority support",
      "Hosting & SSL": "✅ Included",
      "Reports & Analytics": "✅ Sales summary & customer reports",
      "Apps & Integrations": "✅ App store access for plugins",
    },
  },
  {
    name: "Business",
    price: "$99/month",
    features: {
      "Product Limit": "Unlimited products",
      "Product Variants": "✅ Advanced variants with inventory tracking",
      "Checkout System": "✅ Advanced checkout + coupon codes",
      "Mobile Responsive": "✅ Yes",
      "Payment Integration": "✅ Stripe, PayPal, Apple Pay, Google Pay",
      "Shipping Options": "✅ Real-time rates, multiple couriers",
      "Customer Accounts": "✅ Full account management + wishlists",
      "Admin Dashboard": "✅ Advanced admin tools + analytics",
      "Design Customization": "✅ Full design control + templates",
      "Email Notifications": "✅ Automated workflows",
      "SEO & Marketing Tools": "✅ SEO tools + email + pixel",
      "Blog / CMS": "✅ Full CMS capabilities",
      "Support": "✅ 24/7 support + account manager",
      "Hosting & SSL": "✅ Global CDN + daily backups",
      "Reports & Analytics": "✅ Advanced reports + exports",
      "Apps & Integrations": "✅ Full API + 3rd-party integrations",
    },
  },
];

const PlanAndPrice = () => {
  const features = Object.keys(plans[0].features);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Compare Our Plans</h2>
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle text-center">
          <thead className="table-light">
            <tr>
              <th className="text-start" style={{ minWidth: "220px" }}>Features</th>
              {plans.map((plan) => (
                <th key={plan.name}>
                  <div className="fw-bold fs-5">{plan.name}</div>
                  <div className="text-muted">{plan.price}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {features.map((feature) => (
              <tr key={feature}>
                <td className="text-start fw-semibold">{feature}</td>
                {plans.map((plan) => (
                  <td key={plan.name + feature}>{plan.features[feature]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlanAndPrice;

